<template>
    <div class="vx-row match-height">
      <div class="vx-col w-full">
        <vx-card class="mt-2">
          <vs-tabs vs-alignment="fixed" alignment="fixed">
            <vs-tab :label="$t('ShipmentWaitingForCargo')">
              <draft></draft>
            </vs-tab>
            <vs-tab :label="$t('ShipmentWaitingForProcess')">
              <proccessing></proccessing>
            </vs-tab>
            <vs-tab :label="$t('CargoProcessed')">
              <procced></procced>
            </vs-tab>
            <vs-tab :label="$t('CargoDelivered')">
              <delivered></delivered>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </template>
  <script>
  import procced from "./Procced.vue"
  import draft from "./DraftRecieve.vue"
  import proccessing from "./Processing.vue"
  import delivered from "./Delivered.vue"

  export default {
    components: {
      draft,
      procced,
      proccessing,
      delivered,
    },
  };
  </script>